module.exports = __webpack_public_path__ + "img/ncash.64a77506.svg";